enum GenerosPessoa {
    Masculino = 0,
    Feminino = 1
}

export default GenerosPessoa;